import { render } from "./ProjectCard.vue?vue&type=template&id=2b47fa2d&scoped=true"
import script from "./ProjectCard.vue?vue&type=script&lang=js"
export * from "./ProjectCard.vue?vue&type=script&lang=js"

import "./ProjectCard.vue?vue&type=style&index=0&id=2b47fa2d&scoped=true&lang=css"

import exportComponent from "D:\\eestec sajt trenutni\\eestec.etf.rs\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b47fa2d"]])

export default __exports__